import isMobile from '@anm/helpers/is/isMobile';
import { useCallback, useEffect, RefObject } from 'react';

import { Player } from '../../../types';

type UseClickToPlayProps = {
  player: Player | null;
  videoRef: RefObject<HTMLVideoElement>;
};

const useClickToPlay = ({ player, videoRef }: UseClickToPlayProps) => {
  const togglePlay = useCallback(
    ({ target }: Event) => {
      const canTogglePlay = target === videoRef.current;

      canTogglePlay && player?.togglePlay();
    },
    [videoRef.current]
  );

  useEffect(() => {
    if (!player || !videoRef.current || !isMobile() || !player.source) return;

    const bigPlayBtn = videoRef.current.parentElement?.parentElement?.querySelector('.plyr__control--overlaid');

    if (!bigPlayBtn) return;

    bigPlayBtn.addEventListener('click', togglePlay);

    return () => bigPlayBtn.removeEventListener('click', togglePlay);
  }, [player, videoRef.current]);
};

export default useClickToPlay;
